import { ChevronDownIcon, GlobeAltIcon } from '@heroicons/react/24/outline'
import { useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useSiteStore } from '@stores/siteStore'

export default function SiteSwitcher() {
  const { sites, activeSiteId, setActiveSiteId, fetchSites, isLoading } = useSiteStore()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    void fetchSites()
  }, [fetchSites])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const activeSite = sites.find((s) => s.id === activeSiteId)

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        disabled={isLoading}
        className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        <GlobeAltIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />
        <span className="flex-1 truncate text-left">
          {isLoading ? 'Loading…' : (activeSite?.name ?? 'Select site')}
        </span>
        <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />
      </button>

      {open && (
        <div className="absolute left-0 top-full z-50 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900">
          {sites.map((site) => (
            <button
              key={site.id}
              onClick={() => {
                setActiveSiteId(site.id)
                setOpen(false)
              }}
              className={`flex w-full items-start px-3 py-2 text-left text-sm hover:bg-gray-50 dark:hover:bg-gray-800 ${
                site.id === activeSiteId
                  ? 'text-primary-700 dark:text-primary-300'
                  : 'text-gray-700 dark:text-gray-300'
              }`}
            >
              <div>
                <p className="font-medium">{site.name}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">{site.url}</p>
              </div>
            </button>
          ))}
          <div className="border-t border-gray-200 dark:border-gray-700">
            <NavLink to="/settings" className="block px-3 py-2 text-xs text-primary-600 hover:bg-gray-50 dark:text-primary-400 dark:hover:bg-gray-800">
              + Manage sites
            </NavLink>
          </div>
        </div>
      )}
    </div>
  )
}
